import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Podcast from "../components/Podcast";
import CoreValues from "../components/CoreValues";
import Salvation from "../components/Salvation";
import Mission from "../components/Mission";
import News from "../components/News";
import Footer from "../components/Footer";
import AiForm from "../components/AiForm";

export default function AiFormPage() {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastQuestion, setLastQuestion] = useState("");

  const handleSubmit = async (requestText) => {
    setLoading(true);
    setResponse(null);
    setLastQuestion(requestText);

    try {
      const res = await fetch("/api/google-ai.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ description: requestText }),
      });

      const text = await res.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch {
        throw new Error(`Server returned non-JSON response (HTTP ${res.status}).`);
      }

      if (!res.ok || json.success === false) {
        throw new Error(json.error || `Request failed (HTTP ${res.status}).`);
      }

      const answer =
        json.answer ??
        json.candidates?.[0]?.output ??
        (json.candidates?.[0]?.content?.parts?.map((p) => p.text || "").join("\n\n")) ??
        "";

      setResponse({ success: true, question: requestText, answer, raw: json, error: null });
    } catch (err) {
      console.error(err);
      setResponse({ success: false, question: requestText, answer: "", error: err.message || "An unexpected error occurred." });
    } finally {
      setLoading(false);
    }
  };

  const renderAnswer = (text) => {
    if (!text) return null;
    return text.split(/\n{2,}/).map((para, idx) => (
      <p key={idx} className="g-mb-10">
        {para.split("\n").map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < para.split("\n").length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    ));
  };

  return (
    <>
      <Header />

      {/* Intro */}
      <section className="g-bg-white">
        <div className="container g-py-50">
          <h1 className="g-font-weight-300 g-letter-spacing-1 g-mb-2">ASK?</h1>

          <p className="mb-0 g-font-size-16">
            Here you can ask a biblical question and receive an AI-generated response rooted in Scripture and Christian principles.
          </p>

          <ul className="u-list-inline g-font-size-16 g-mt-10">
            <li className="list-inline-item g-mr-7">
              <Link className="u-link-v5 g-color-main" to="/prayer">
                Prayer Request
              </Link>
              <i className="fa fa-angle-right g-ml-7" />
            </li>
            <li className="list-inline-item g-color-primary">
              <span>If you have further questions or need personal ministry, please email or contact us.</span>
            </li>
          </ul>
        </div>
      </section>

      {/* Form + Answer */}
      <section className="container g-py-75">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            {response?.success === false && response?.error && (
              <div className="alert alert-danger g-mb-30" role="alert">
                <strong>Oops!</strong> {response.error}
              </div>
            )}

            {response?.success && response?.answer && (
              <div className="g-mb-30 g-brd-around g-brd-gray-light-v4 g-pa-30 g-bg-white">
                <h4 className="g-mb-15 g-color-black">AI Response</h4>

                {!!lastQuestion && (
                  <div className="g-mb-20">
                    <div className="g-font-weight-600 g-color-gray-dark-v2 g-mb-5">Your Question</div>
                    <div className="g-bg-gray-light-v5 g-pa-15" style={{ borderRadius: 10 }}>
                      {lastQuestion}
                    </div>
                  </div>
                )}

                <div className="g-font-weight-600 g-color-gray-dark-v2 g-mb-5">Answer</div>
                <div className="g-font-size-16 g-line-height-2 g-color-gray-dark-v2">{renderAnswer(response.answer)}</div>
              </div>
            )}

            <AiForm onSubmit={handleSubmit} loading={loading} />
          </div>
        </div>
      </section>

      <Podcast />
      <CoreValues />
      <Salvation />
      <Mission />
      <News />
      <Footer />
    </>
  );
}